import React, { useRef } from "react";
import Tooltip from "./Tooltip.jsx";
import "./guides.css";
import Seo from "../Seo.jsx";
import guidesConfig from "../../config/guidesConfig";
import smu from './images/smuefa.png'
import b365u from './images/b365uefa.png'
import omu from './images/om-uefa.png'
import mp from './images/match-picker-uefa.png'
import mp2 from './images/match-picker-uefa2.png'

import { OddsMonkeyFT } from "../Affiliate/Om.jsx"
import ScrollModal from '../ui/ScrollModal.jsx';


const OddsMonkeyGuideSimple = () => {
  const scrollRef = useRef(null);
  const meta = guidesConfig.OddsMonkeyGuideSimple?.seo || {};

  return (
    <div className="guides-content">
            <Seo title={meta.title} description={meta.description} url={guidesConfig.OddsMonkeyGuideSimple?.route || "/guides"}/>

      <p>
      For matched bettors to lock in profit, we need to find close matches between <span className="key">bookmaker odds</span> and <span className="key">exchange odds</span>.
      </p>
      <p>To get close matches, we either have to...</p>
      <ul>
        <li>Find them ourselves</li>
        <li>Use an <span className="key">odds matching tool</span></li>
      </ul>
      <p><strong>We openly recommend <a href="https://www.oddsmonkey.com/affiliates/affiliate.php?id=66317">OddsMonkey</a>, because we quite simply think it's the best matched betting tool available.</strong></p>    
      <h6 className="info">
        This is important – we earn a fee when we refer people to OddsMonkey. We are <em>only</em> happy to work with them because we genuinely believe they're the best choice. We could work with any company with a matched betting tool, but we've chosen OddsMonkey because we think they're right for most matched bettors.
      </h6>
      <p>
      <a href="https://www.oddsmonkey.com/affiliates/affiliate.php?id=66317">OddsMonkey</a> is a matched betting tool that helps you find offers, guides you through them, helps you matches and make bets, and more. OddsMonkey <strong>saves you time</strong>, helps you <strong>profit faster</strong> and makes the whole process <strong>far less stressful</strong>.
      </p>

      <h2>What is an odds matcher?</h2>
      <p>
        <span className="key">Odds matchers</span> find close matches between bookmaker odds and exchange odds.
      </p>
      <p>Let's imagine we have a <span className="key">Bet £10, Get £10</span> offer at <Tooltip content="A major bookmaker.">Bet365</Tooltip> for the Champions League.</p>
      <div className="grid-fixed g2">
        <div className="col">
          <h4>Looking for matches on Bet365:</h4>
          <p>We need to <span className="back">back</span> an outcome to qualify for the free bet.</p>
          <img src={b365u} alt="Bet365 UEFA matches" />
        </div>
        <div className="col">
          <h4>Looking for matches on Smarkets:</h4>
          <p>We need to <span className="lay">lay</span> the outcome to cancel out the bet.</p>
          <img src={smu} alt="Smarkets UEFA matches" />
        </div>
      </div>

     
      <h3>Option 1: Find a match manually</h3>
      <p>We could use the <a href="/calculators/match-picker">Match Picker tool</a> to find the best odds.</p>
      <p>Enter all back and lay odds for all the outcomes into the picker, and it will highlight the closest match:</p>

      <div className="grid-fixed g2">
        <div className="col">
        <h4>Inputting all the odds:</h4>
          <p>We need to input all the odds we want to compare.</p>
          <img src={mp} alt="MatchedEdge match picker" />
        </div>
        <div className="col">
        <h4>Identifying the closest match:</h4>
          <p>The match picker chooses the closest match.</p>
          <img src={mp2} alt="MatchedEdge match picker results" />
        </div>
      </div>
      <h3>Option 2: Use a tool</h3>

      <p>
        Instead of manually checking dozens of outcomes from multiple events for our qualifying bet, we can use an <span className="key">odds matcher</span> to find the closest odds available.
      </p>
      <h6 className="info">
        Key Info: A rating near 100% indicates an optimal match to maximise profit.
      </h6>
      <p>
        We load up OddsMatcher, filter by "Bet365" and "Champions League", then sort by rating. You might see:
      </p>
      <img src={omu} alt="OddsMonkey UEFA matches" />
      <p><a href="https://www.oddsmonkey.com/affiliates/affiliate.php?id=66317">OddsMonkey</a> can filter all this information for us and tell us that the best match available is a bet on <span className="key">Paris St-G</span>  vs. Aston Villa, with <span className="back">back</span> odds of <span className="key">1.40</span> at Bet365, and <span className="lay">lay</span> odds of <span className="key">1.44</span> at the Smarkets exchange.</p>

      <h2>Why the OddsMatcher Is Ideal for Beginners (and Pros!)</h2>
      <p>
        It can feel like there's a lot to learn in matched betting at first, but we love <a href="https://www.oddsmonkey.com/affiliates/affiliate.php?id=66317">OddsMonkey</a> because it genuinely makes it simple.
        </p>
        <p>Their key tool is the <span className="key">OddsMatcher</span>, which you just saw above. </p>
      <p>
      Its <strong>intuitive</strong>, <strong>visual</strong> and <strong>does the hard maths for you</strong>. It shows exactly:
      </p>
      <ul>
        <li>What to bet on</li>
        <li>How much to stake (both back and lay)</li>
        <li>Your expected profit or loss</li>
      </ul>
      <p>
        It even links directly to the bookmaker and exchange sites so you can place your bets quickly – no need to hunt for markets manually. Plus, they integrate directly with betting exchanges like <span className="key">Smarkets</span>, <span className="key">Betfair</span>, <span className="key">Matchbook</span>, <span className="key">Betdaq</span> and <span className="key">BetConnect</span>. So you get one-click lay betting, which reduces mistakes and speeds up your betting.
        
      </p>

{/* 
      <CTALarge 
        to="/oddsmatcher-calculator" 
        text="Go to OddsMatcher Calculator" 
        icon={Calculator} 
      /> */}

      <h2>Beyond the OddsMatcher: More Tools to Grow With</h2>
      <p>
        While OddsMatcher is the essential starting point, <a href="https://www.oddsmonkey.com/affiliates/affiliate.php?id=66317">OddsMonkey</a> have a full suite of really great tools as you gain experience to help you seriously boost your profit, including...
      </p>
      <ul>
        <li><strong>2UP Matcher</strong> – Unlock early payout profits</li>
        <li><strong>Extra Place Matcher</strong> – Find profitable each-way bets on horse racing</li>
        <li><strong>BOG Matcher</strong> – Capitalise on Best Odds Guaranteed offers</li>
        <ScrollModal scrollContainerRef={scrollRef} props={{ctaKey: "om1"}} />

        <li><strong>Dutch Matcher</strong> – Capitalise on odds discrepancies between bookies</li>
        <li><strong>Racing Matcher & Acca Finder</strong> – Perfect for everyday reloads</li>
        <li><strong>Casino and Bingo Tools</strong> – Earn extra with casino offers with positive expected value</li>
        <li><strong>Profit Tracker</strong> – Replace clunky spreadsheets with easy bet tracking</li>
      </ul>
      <h6 className="info">Don't worry if these don't mean much to you at the moment! We just want to show you how much more there is to OddsMonkey.</h6>

      <h2>Exclusive Bonuses: 0% Smarkets Commission + BetConnect</h2>
      <p>
        As an OddsMonkey member, you enjoy ongoing 0% commission at Smarkets. Simply place one bet via OddsMatcher per month and you’re set. In addition, through an exclusive link with BetConnect, you can access some of the best lay odds on the market and avoid odds changes with a handy 60-second odds lock.
      </p>
      <h6 className="info">
        0% commission means you won’t pay fees when using Smarkets, which would eat into your profits.
      </h6>

      <h2>Is OddsMonkey Worth the Subscription?</h2>
      <p><strong>You don't need to have a matched betting tool.</strong></p>
      <p>If you just want to do the odd bit of matched betting casually, you can find your own matches or use a free tool.</p>
      <p>
        If you are after a more substantial profit, you should have a high-quality tool. <strong>In our opinion, the OddsMatcher alone can justify the monthly fee</strong>. 
      </p>
      <p>Many users earn back the fee with just one or two offers.</p>
      <p><strong>MatchedEdge users get a free trial of OddsMonkey, and it's a brilliant way to try it out and make your first money matched betting without paying for the tool.</strong></p>
      
      <OddsMonkeyFT/>
    </div>
  );
};

export default OddsMonkeyGuideSimple;
